module.exports = __webpack_public_path__ + "img/joosh.f486ab4b.webp";